<template>
  <div class="project__item">
    <div class="project__lightbox" v-if="showLightbox">
      <vue-image-lightbox-carousel
        ref="lightbox"
        :show="showLightbox"
        @close="showLightbox = false"
        :images="images"
        @change="changeImage"
      >
      </vue-image-lightbox-carousel>
    </div>
    <h2 class="project__title">
      {{ first_line }} <br />
      {{ second_line }}
    </h2>
    <div class="project__image" @click="openLightbox">
      <img
        class="project__img"
        :src="require(`@/assets/${image}`)"
        :alt="name"
      />
      <button class="project__button" @click="openLightbox">
        <div class="project__svg--mobile">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="50"
            height="50"
            fill="none"
          >
            <path
              fill="#fff"
              d="M5 50a5 5 0 0 1-5-5v-8.152a4.819 4.819 0 1 1 9.637 0v3.515h3.515a4.819 4.819 0 1 1 0 9.637H5Zm31.848 0a4.819 4.819 0 1 1 0-9.637h3.515v-3.515a4.819 4.819 0 1 1 9.637 0V45a5 5 0 0 1-5 5h-8.152ZM4.818 17.97A4.819 4.819 0 0 1 0 13.153V5a5 5 0 0 1 5-5h8.152a4.819 4.819 0 1 1 0 9.637H9.637v3.515A4.819 4.819 0 0 1 4.82 17.97Zm40.363 0a4.819 4.819 0 0 1-4.818-4.818V9.637h-3.515a4.819 4.819 0 1 1 0-9.637H45a5 5 0 0 1 5 5v8.152a4.819 4.819 0 0 1-4.819 4.819Z"
            />
          </svg>
        </div>
        <div class="project__svg--desktop">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="114"
            height="114"
            fill="none"
          >
            <path
              fill="#fff"
              d="M5 114a5 5 0 0 1-5-5V78.027a5 5 0 0 1 5-5h11.973a5 5 0 0 1 5 5v14h14a5 5 0 0 1 5 5V109a5 5 0 0 1-5 5H5Zm73.027 0a5 5 0 0 1-5-5V97.027a5 5 0 0 1 5-5h14v-14a5 5 0 0 1 5-5H109a5 5 0 0 1 5 5V109a5 5 0 0 1-5 5H78.027ZM5 40.973a5 5 0 0 1-5-5V5a5 5 0 0 1 5-5h30.973a5 5 0 0 1 5 5v11.973a5 5 0 0 1-5 5h-14v14a5 5 0 0 1-5 5H5Zm92.027 0a5 5 0 0 1-5-5v-14h-14a5 5 0 0 1-5-5V5a5 5 0 0 1 5-5H109a5 5 0 0 1 5 5v30.973a5 5 0 0 1-5 5H97.027Z"
            />
          </svg>
        </div>
      </button>
    </div>
    <div class="project__content">
      <FoldOut :description="description" :label="label" :slug="slug" />
    </div>
  </div>
</template>

<script>
import FoldOut from "@/components/FoldOut.vue";
// import LightboxImage from "@/components/LightboxImage.vue";
import VueImageLightboxCarousel from "vue-image-lightbox-carousel";

export default {
  name: "ProjectItem",
  components: {
    FoldOut,
    VueImageLightboxCarousel,
    // LightboxImage,
  },
  props: {
    name: String,
    first_line: String,
    second_line: String,
    description: String,
    label: String,
    image: String,
    images: Array,
    slug: String,
  },
  data() {
    return {
      showLightbox: false,
    };
  },
  methods: {
    openLightbox() {
      this.showLightbox = true;
      this.$refs.lightbox.showImage(-1);
    },
  },
};
</script>

<style scoped>
.project__item {
  margin-top: -20px;
}

.project__title {
  transform: translateY(calc(50% + 5px));
  z-index: 1;
  position: relative;
  padding-left: 10px;

  font-family: "Saira Condensed Bold", sans-serif;
  font-weight: 700;
  font-size: 100px;
  line-height: 80px;
  color: var(--color-yellow);
  text-transform: uppercase;
}

.project__video {
  max-width: 100%;
}

.project__close {
  position: absolute;
  top: 10px;
  right: 10px;
  border: none;
  background-color: var(--color-yellow);
  z-index: 1;
  border-radius: 50%;
  width: 88px;
  height: 88px;
  transition: transform 0.3s ease-in-out;

  svg {
    width: 37px;
  }
}

.project__image {
  max-width: 100%;
  position: relative;
}

.project__img {
  width: 100%;
}

.project__button {
  position: absolute;
  left: 11px;
  bottom: 19px;
  border: none;
  background-color: var(--color-yellow);
  z-index: 1;
  border-radius: 50%;
  width: 88px;
  height: 88px;
  transition: transform 0.3s ease-in-out;
  outline: none;
  cursor: pointer;

  svg {
    width: 50px;
  }
}

@media only screen and (min-width: 768px) {
  .project__button {
    width: 200px;
    height: 200px;
    left: 35px;
    bottom: 35px;

    svg {
      width: 133px;
      margin-left: 20px;
    }
  }
}

.project__button:hover {
  transform: scale(1.1);
  transition: transform 0.3s ease-in-out;
}

.project__content {
}

.project__lightbox {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
}

.project__lightbox-img {
  max-width: 100%;
  max-height: 100%;
}

@media only screen and (max-width: 768px) {
  .project__svg--mobile {
    display: block;
  }

  .project__svg--desktop {
    display: none;
  }
}

@media only screen and (min-width: 768px) {
  .project__svg--mobile {
    display: none;
  }

  .project__svg--desktop {
    display: block;
  }
}
</style>

<style>
.vue-lightbox-info {
  display: none;
}
</style>
